import { useAuth0 } from '@auth0/auth0-react';
import { openInNewTab } from '@strata/helper-functions';
import { Header as StrataHeader } from '@strata/react-header';
import { type ComponentProps, useState } from 'react';

import { UserProfileDialog } from 'components/header/dialogs/UserProfileDialog';
import { FeatureCarousel } from 'components/header/FeatureCarousel';
import { clearDataForLogout } from 'services/authHelpers';
import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Header = () => {
    const { isAuthenticated, logout } = useAuth0();

    const getNavTabs = (): ComponentProps<typeof StrataHeader>['navBar'] => {
        if (!isAuthenticated) {
            return [];
        }

        return [
            {
                label: 'Intake Cases',
                to: AppRoutes.intakeCases,
                children: [
                    { label: 'Active Intake Cases', to: AppRoutes.activeIntakeCases },
                    { label: 'Monitoring Intake Cases', to: AppRoutes.monitoringIntakeCases },
                    { label: 'Archived Intake Cases', to: AppRoutes.archivedIntakeCases },
                ],
            },
            {
                label: 'Intake Sources',
                to: AppRoutes.intakeSources,
                children: [
                    { label: 'Active Intake Sources', to: AppRoutes.activeIntakeSources },
                    { label: 'Archived Intake Sources', to: AppRoutes.archivedIntakeSources },
                ],
            },
        ];
    };

    const [showUserProfileDialog, setShowUserProfileDialog] = useState(false);

    // Load home screen messages & carousels on login
    useGetHomeScreenMessagesQuery(undefined, { skip: !isAuthenticated });

    const onLogOutClick = () => {
        (async () => {
            clearDataForLogout();
            await logout({
                logoutParams: { returnTo: `${window.location.origin}${AppRoutes.loggedOut}` },
            });
        })();
    };

    return (
        <>
            <StrataHeader
                navBar={getNavTabs()}
                onProfileClick={() => setShowUserProfileDialog(true)}
                onLogOutClick={onLogOutClick}
                onTermsOfUseClick={() => openInNewTab(AppRoutes.termsOfUse)}
                onPrivacyPolicyClick={() => openInNewTab(AppRoutes.privacyPolicy)}
                appVersion={process.env.REACT_APP_VERSION}
                fmhEnvironmentForTag={process.env.REACT_APP_ENV}
            />
            {isAuthenticated && (
                <>
                    <UserProfileDialog
                        onSecondaryButtonClick={() => setShowUserProfileDialog(false)}
                        isOpen={showUserProfileDialog}
                    />
                    <FeatureCarousel />
                </>
            )}
        </>
    );
};
